import moment from 'moment-timezone';

export class PostProcessingCommissionAuditGrouped {
	public id: number | string;
	public reportDate: Date;
	public customerId: string;
	public customerName: string;
	public contractId: string;
	public contractNum: string;
	public contractLocationId: string;
	public expirationDate: Date;
	public isResidential: boolean;
	public externalId: string;
	public utilityAccountNum: string;
	public supplierId: string;
	public supplierName: string;
	public asOfForecasted: number;
	public forecastedUsage: number;
	public lateActual: number;
	public actualTotal: number;
	public recovered: number;
	public asOfActual: number;
	public actualUsage: number;
	public asOfCumulativeDiff: number;
	public issue: string;
	public status: string;
	public deviation: number;
	public receivableAuditIssueOperationStatusId: number;
	public forecastedDate: Date;
	public postProcessingStatus: string;
	public dateOffset: number;
	public originalDate: Date;
	public receivableOperationStatusTypeId: number;
	public receivableAuditIssueTypeId: number;
	public postProcessingCommissionAuditStatusId: number;
	public postProcessingCommissionAuditStatusTypeId: number;
	public description: string;
	public minPendingCommissionId: string;
	public commissionTypeId: number;
	public forecastedMeterStartDate: Date;
	public forecastedMeterEndDate: Date;
	public meterStartDate: Date;
	public meterEndDate: Date;
	public isReviewed: boolean;
	public flagReason: string;
	public priority: number;
	public cumulativeForecastReceivable: number;
	public cumulativeActualReceivable: number;
	public cumulativeDiff: number;
	public cumulativeRatio: number;
	public cumulativeSupplierCommissionResponseReasonDescription: string;
	public cumulativeSupplierNote: string;
	public lastSupplierCommissionEmailLogCreatedAt: Date;

	constructor(postProcessingCommissionAuditGrouped: PostProcessingCommissionAuditGrouped) {
		Object.assign(this, postProcessingCommissionAuditGrouped);

		this.reportDate = this.reportDate ? new Date(moment(this.reportDate).format('MMM DD, YYYY hh:mm:ss a')) : this.reportDate;
		this.forecastedDate = this.forecastedDate ? new Date(moment(this.forecastedDate).format('MMM DD, YYYY hh:mm:ss a')) : this.forecastedDate;
		this.forecastedMeterStartDate = this.forecastedMeterStartDate
			? new Date(moment(this.forecastedMeterStartDate).format('MMM DD, YYYY hh:mm:ss a'))
			: this.forecastedMeterStartDate;
		this.forecastedMeterEndDate = this.forecastedMeterEndDate
			? new Date(moment(this.forecastedMeterEndDate).format('MMM DD, YYYY hh:mm:ss a'))
			: this.forecastedMeterEndDate;
		this.meterStartDate = this.meterStartDate ? new Date(moment(this.meterStartDate).format('MMM DD, YYYY hh:mm:ss a')) : this.meterStartDate;
		this.meterEndDate = this.meterEndDate ? new Date(moment(this.meterEndDate).format('MMM DD, YYYY hh:mm:ss a')) : this.meterEndDate;
		if (postProcessingCommissionAuditGrouped?.lastSupplierCommissionEmailLogCreatedAt) {
			this.lastSupplierCommissionEmailLogCreatedAt = new Date(postProcessingCommissionAuditGrouped.lastSupplierCommissionEmailLogCreatedAt);
		}
	}
}
